import styled from 'styled-components';

export const ChildPanel = styled.div`
  padding-left: 5px;
  box-sizing: border-box;
`;

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(26, 30, 55, 1);
  border: 1px solid rgba(10, 236, 213, 1);

  overflow-y: scroll;

  /*控制整个滚动条*/
  ::-webkit-scrollbar {
    background: rgba(11, 14, 30, 1);
    width: 3px;
    /* height: 10px; */
    background-clip: padding-box;
  }

  /*滚动条两端方向按钮*/
  ::-webkit-scrollbar-button {
    background-color: rgba(14, 254, 251, 1);
  }

  /*滚动条中间滑动部分*/
  ::-webkit-scrollbar-thumb {
    background: rgba(14, 254, 251, 1);
    border-radius: 2px;
  }

  /*滚动条右下角区域*/
  ::-webkit-scrollbar-corner {
    background-color: rgba(14, 254, 251, 1);
  }
`;

export const CategoryFloor = styled.div``;

export const FatherFloor = styled.div`
  height: 46px;
  line-height: 46px;
  display: flex;
  align-items: center;

  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  padding-left: 26px;
  padding-right: 26px;
  box-sizing: border-box;

  position: relative;
  z-index: 1;

  &::before {
    content: '';
    display: block;
    position: absolute;
    height: 1px;
    left: 26px;
    right: 0;
    bottom: 0;
    border-top: 1px dashed rgba(74, 86, 130, 0.2);
  }

  > .name {
    display: block;
    cursor: pointer;
    &:hover {
      color: rgba(24, 246, 254, 1);
    }
  }

  > .more {
    display: block;
    width: 7px;
    height: 9px;
    opacity: 0.5;
    margin-left: 10px;
  }
`;

export const ChildrenFloor = styled.div`
  display: flex;
  flex-wrap: wrap;

  width: 100%;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(222, 222, 222, 1);
  padding-left: 26px;
  box-sizing: border-box;
  /* overflow: hidden; */
  > .name {
    display: block;
    height: 46px;
    line-height: 46px;
    flex-shrink: 0;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 31px;
    }

    &:hover {
      color: rgba(24, 246, 254, 1);
    }
  }
`;
